// extracted by mini-css-extract-plugin
export default {"button":"LandscapeCommoditiesTemplate_button__uYxuC","tableCell":"LandscapeCommoditiesTemplate_tableCell__A4NHn","tableRow":"LandscapeCommoditiesTemplate_tableRow__msx1S"};